/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */

import NavbarNotAuth from '../userNotAuth/components/navbarNotAuth'
import { useNavigate } from 'react-router-dom'
import { NavbarBottomAdmin, NavbarTopAdmin } from '../admin/components'
import axios from 'axios'
import { useEffect, useState, useRef } from 'react'
import DivBottom from '../userNotAuth/components/divBottom'
import ReactQuill from 'react-quill-new'

function ProfiloArtista() {
    const navigate = useNavigate()
    const userId = localStorage.getItem('idUser')
    const [artisti, setArtisti] = useState([])
    const [dati, setDati] = useState({})
    const [msg, setMsg] = useState({ noProfilo: null })

    const confirmElimina = useRef()
    const corpo = useRef()//per opacity diminuita quando clicco elimina artista

    async function getArtista() {
        try {
            const res = await axios.post(`/getArtista/${userId}`)
            setArtisti(res.data.filter(item => item.sezione === "artista"))
            if (res.data.length === 0) setMsg({
                noProfilo: 'Non hai ancora nessun profilo come artista da mostrare oppure' +
                    ' hai inserito un artista ma lo staff deve ancora approvarlo.'
            })
        } catch (err) { console.log(err) }
    }
    function modifica(artista) {
        setTimeout(() => {
            navigate('/editArtista', {
                replace: true,
                state: { artista }
            })
        }, 300)
    }

    const approva = (stato) => {
        try {
            axios.post(`/approvaArtista/${dati.id}/${dati.emailUser}/${stato}/${dati.idUser}`).then(res => {
                confirmElimina.current.style.top = '-50%'
                corpo.current.style.opacity = "1"
                document.body.style.overflow = "scroll"
                if (stato === 'delete') {
                    if (dati.img) { axios.delete(`/delete-img/${dati.img}`) }
                    if (dati.video) { axios.delete(`/delete-video/${dati.video}`) }
                }
                setTimeout(() => { window.location.reload() }, 300)
            })
        } catch (err) { console.log(err) }
    }

    useEffect(() => { if (!userId) { navigate('/') } else getArtista() }, [userId])
    return (<>
        {localStorage.getItem('logged') && localStorage.getItem('email') ? <div><NavbarTopAdmin /> <NavbarBottomAdmin /></div>
            : <NavbarNotAuth />}
        <br />
        <div ref={confirmElimina} style={{
            position: 'fixed',
            backgroundColor: 'snow',
            top: '-50%',
            left: '0',
            right: '0',
            margin: 'auto',
            width: '70%',
            height: '40%',
            padding: '2rem',
            zIndex: '1',
            borderRadius: '10px',
            border: '1px solid black',
            textAlign: 'center',
            transition: '.2s'
        }}>
            Eliminare definitivamente <i>{dati.genere}</i> ?
            <div className='mt-5'>
                <button className='float-start btn btn-danger'
                    onClick={() => { approva('delete') }}>Procedi</button>
                <button className='float-end btn btn-success'
                    onClick={() => {
                        confirmElimina.current.style.top = '-50%'
                        corpo.current.style.opacity = "1"
                        document.body.style.overflow = "scroll"
                    }}>Annulla</button>
            </div>
        </div>
        <h1 style={{ cursor: 'pointer', margin: '2em 0 0 .5em' }} onClick={() => { navigate('/', { replace: true }) }}>◁</h1>
        <div className='container' ref={corpo}>
            <h3 style={{ marginTop: '1rem', textAlign: 'center' }}>PROFILO ARTISTA</h3>
            {msg.noProfilo && <h5 style={{ margin: '3em 0 14rem 0' }}>{msg.noProfilo}</h5>}
            {artisti &&
                artisti
                    // .filter(item => (item.accettazione === 'true' || item.accettazione === 'rejection'))
                    .map((artista) => {
                        let flag, write
                        if (artista.accettazione === 'rejection') {
                            flag = '0.7'
                            write = '⛔ Artista rifiutato, i contenuti non sono in linea con i nostri standard. ' +
                                "Modifica il contenuto usando un linguaggio più moderato"
                        }

                        if (artista.accettazione === 'false') {
                            flag = '.7'
                            write = 'PROFILO ARTISTA IN FASE DI APPROVAZIONE'

                        }

                        return (
                            <div key={artista.id} style={{ opacity: flag, marginTop: '3rem' }} className='bodyPadding'>
                                <h4 style={{ color: 'red', textAlign: 'center' }}><b>{write}</b></h4>
                                <div className='mt-3'>
                                    {artista.img ?
                                        <img src={`https://leuro-bucket.s3.amazonaws.com/${artista.img}`} style={{ maxWidth: '200px', maxHeight: '200px' }} />
                                        :
                                        <img src={require('../userNotAuth//image/icons8-impostazioni-amministratore-maschio-32.png')} style={{ borderRadius: '50%', width: '30px', height: '30px', marginTop: '1rem' }} />
                                    }
                                    <span className='mt-1 float-end'>View: {artista.view}</span>
                                </div>
                                <hr />
                                <div className='mt-2'><b>{artista.cognome} {artista.nome}</b> ({artista.città})
                                    <div><i>{artista.genere}</i></div>
                                </div>
                                {artista.gruppo &&
                                    <div style={{ fontWeight: '600' }}>- {artista.gruppo} -</div>
                                }
                                {artista.durata &&
                                    <div>Durata show: {artista.durata}</div>
                                }
                                {artista.cachet &&
                                    <div>Cachet: € {artista.cachet}</div>
                                }
                                <div>Numero componenti: {artista.numero}</div>

                                <p className='mt-5 text-center'>DESCRIZIONE</p>
                                <ReactQuill className="textarea-quill"
                                    value={artista.descrizione}
                                    theme="snow"
                                    modules={{
                                        toolbar: [
                                            ['bold', 'italic'],
                                        ]
                                    }}
                                />

                                <div className='mt-3'>
                                    {artista.telefono &&
                                        <div><img src={require('../userNotAuth/image/icons8-telefono-cellulare-48.png')} width='25rem' style={{ marginRight: '1rem' }} />
                                            {artista.telefono}
                                        </div>
                                    }
                                    <div className='mt-1'><img src={require('../userNotAuth/image/icons8-nuovo-messaggio-48.png')} width="25rem" style={{ marginRight: '1rem' }} />
                                        {artista.emailUser}
                                    </div>

                                    {/* ------------------------- VIDEO ----------------------- */}
                                    {artista.video &&
                                        <div className='mt-5' style={{ border: '1px solid lightgrey', borderRadius: '5px', padding: ' 15px' }}>
                                            <div className='text-center mt-3'>
                                                <video src={`https://leuro-bucket.s3.amazonaws.com/video/${artista.video}`} id={'videoPreview'}
                                                    style={{ width: '100%', borderRadius: '5px' }} controls />
                                            </div>
                                        </div>
                                    }
                                </div>

                                {artista.url &&
                                    <div className='mt-2'>Sito web: <i style={{ fontWeight: '600' }}>
                                        <a href={artista.url} target='_blank'>{artista.url.substring(0, 28)}...</a>
                                    </i>
                                    </div>
                                }
                                {artista.fb &&
                                    <div className='mt-2'>F Book: <i style={{ fontWeight: '600' }}>
                                        <a href={artista.fb} target='_blank'>{artista.fb.substring(0, 28)}...</a>
                                    </i>
                                    </div>
                                }
                                {artista.youtube &&
                                    <div className='mt-2'>Y Tube: <i style={{ fontWeight: '600' }}>
                                        <a href={artista.youtube} target='_blank'>{artista.youtube.substring(0, 28)}...</a>
                                    </i>
                                    </div>
                                }
                                <div className='mt-4' style={{ marginBottom: '6rem' }}>
                                    <button className='btn btn-primary float-start' onClick={() => { modifica(artista) }}
                                        style={{ fontSize: 'medium' }}>
                                        Modifica
                                    </button>
                                    <button className='btn btn-danger float-end' style={{ fontSize: 'medium' }}
                                        onClick={() => {
                                            setDati(artista)
                                            document.body.style.overflow = "hidden"
                                            corpo.current.style.opacity = ".4"
                                            confirmElimina.current.style.top = '30%'
                                        }}>
                                        Elimina
                                    </button>
                                </div>
                            </div>
                        )
                    })}
            <button style={{ cursor: 'pointer', margin: '2em 0 0 .5em' }} onClick={() => { navigate('/', { replace: true }) }}>◁<i> indietro</i></button>
            {artisti.length === 0 && <h4 className='text-center mt-5'>Non hai nessun profilo artista</h4>}
        </div>
        <DivBottom />
    </>)
}
export default ProfiloArtista